var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8778_199361)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.14453,
    y: 2,
    width: 29.2435,
    height: 29,
    rx: 4,
    fill: "#FF5959"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8778_199361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0701 17.1901L17.0592 17.2002H14.5842C14.1936 17.2002 13.8771 16.8863 13.8771 16.4989C13.8771 16.1117 14.1936 15.7977 14.5842 15.7977H17.7664V15.8092C18.4627 15.8092 17.3758 15.7977 17.7664 15.7977C18.157 15.7977 18.4627 15.8166 18.4735 15.7977H20.9486C21.3392 15.7977 21.6557 16.1117 21.6557 16.4989C21.6557 16.8863 21.3392 17.2002 20.9486 17.2002H18.4735L18.4627 17.1901C17.7664 17.1901 18.157 17.1901 17.7664 17.1901C17.3758 17.1901 17.0701 17.1901 17.0701 17.1901ZM24.1668 10.1525C22.4572 8.45713 20.1841 7.52344 17.7664 7.52344C15.3487 7.52344 13.0756 8.45713 11.366 10.1525C9.65638 11.8479 8.71484 14.102 8.71484 16.4996C8.71484 18.8972 9.65638 21.1514 11.366 22.8468C13.0756 24.5421 15.3487 25.4758 17.7664 25.4758C19.4216 25.4758 21.0411 25.0285 22.4499 24.1822C22.784 23.9815 22.8908 23.5504 22.6884 23.2192C22.4861 22.8878 22.0512 22.782 21.7172 22.9826C20.5294 23.6961 19.1632 24.0733 17.7664 24.0733C13.5552 24.0733 10.1291 20.6757 10.1291 16.4996C10.1291 12.3235 13.5552 8.92597 17.7664 8.92597C21.9775 8.92597 25.4036 12.3235 25.4036 16.4996C25.4036 17.993 24.9559 19.4464 24.1087 20.7032C23.8915 21.0251 23.9788 21.4607 24.3035 21.676C24.6281 21.8911 25.0673 21.8046 25.2844 21.4827C26.2876 19.9946 26.8179 18.2714 26.8179 16.4996C26.8179 14.102 25.8764 11.8479 24.1668 10.1525Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8778_199361",
    x: 0.144531,
    y: 0,
    width: 37.2441,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8778_199361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8778_199361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8778_199361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1031,
    height: 17.9524,
    fill: "white",
    transform: "translate(8.71484 7.51562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusRedIcon);
export default __webpack_public_path__ + "static/media/minus-red-icon.330788fc65db12f6f38b88e7ebd5133e.svg";
export { ForwardRef as ReactComponent };